import { defineMessages } from 'react-intl-next';

export const messages = defineMessages({
	addButtonText: {
		id: 'company-hub.color-picker.custom-palette.add-button-text',
		description:
			'Button text of custom palette input field when on call to action, elevates custom input to curated palette',
		defaultMessage: 'Add',
	},
});
